import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {Dialog} from 'primereact/dialog'
import {forwardRef, useImperativeHandle, useMemo} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import CustomForm from '../form-utils/CustomForm'
import {component, formLayout} from '../form/Constant'
import {severityNotification} from '../notification/NotificationConstant'
import {showNotification} from '../notification/NotificationService'

const ExaminationUploaderForm = forwardRef(({callBack = () => {}}, ref) => {
    useSignals()
    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
        hideForm: handleHideForm,
    }))

    const {translateKeys, translateCommons} = TranslateUtils()
    const data = useSignal({})
    const visible = useSignal(false)

    const dataList = useMemo(() => {
        if (!data.value || !data.value?.parentKey || !data.value?.childKey) {
            return []
        }

        return [
            {
                key: data.value?.childKey,
                label: data.value?.label,
                component: component.fileUpload,
                initialValue: data.value?.images,
                multiple: true,
            },
        ]
    }, [data.value])

    const handleShowForm = value => {
        data.value = value
        visible.value = true
    }
    const handleHideForm = () => {
        data.value = {}
        visible.value = false
    }

    const handleOnSubmit = value => {
        if (callBack) {
            callBack({
                parentKey: data.value?.parentKey,
                key: data.value?.childKey,
                value: value[data.value?.childKey],
                type: 'images',
            })
        }

        showNotification(
            severityNotification.success,
            'Upload Image Successfully !',
        )

        handleHideForm()
    }

    return (
        <div>
            <Dialog
                header={
                    <h5 className="mb-0 font-bold">
                        <strong>
                            {translateCommons('Review Examination Image')}
                        </strong>
                    </h5>
                }
                style={{width: '60vw'}}
                breakpoints={{
                    '960px': '75vw',
                    '641px': '100vw',
                }}
                visible={visible.value}
                onHide={() => (visible.value = false)}>
                <CustomForm
                    onSubmit={handleOnSubmit}
                    layout={formLayout.inline}
                    dataList={dataList}
                />
            </Dialog>
        </div>
    )
})
export default ExaminationUploaderForm
